import React from 'react';
import { ContentContainer } from 'src/components/ContentContainer/contentContainer';
import { Flex } from '@chakra-ui/react';
import { InfoSummary } from './InfoSummary/infoSummary';
import { Spotlight } from './Spotlight/spotlight';
import { Header } from '../../components/Header/header';
import { Featured } from './Featured/featured';
import { Airdrop } from './Airdrop/airdrop';
import { GamesFeaturing } from './Featured/gamesFeaturing';
import { AirdropBanner } from './AirdropBanner/airdropBanner';
import { Onboarding } from './Onboarding/onboarding';
import { TransactionsView } from './TransactionsView/transactionsView';
import { Color } from 'src/theme/color';
import { KeyOpener } from './KeyOpener/KeyOpener';

export const HomePage = () => (
	<ContentContainer>
		<Header />
		<InfoSummary />
		<Flex
			w="100%"
			flexDirection="column"
			flexWrap="wrap"
			alignItems="center"
			background={Color.BACKGROUND_LIGHT}
			gridGap="72px"
			pt={{ base: '48px', hashup: '86px' }}
			paddingX={{ hashup: '32px', xl: '0' }}
			overflow="hidden"
		>
			<Onboarding />
			<KeyOpener />
			<Featured data={GamesFeaturing} />
			{/* <AirdropBanner /> */}
			<Spotlight />
			{/* <Airdrop /> */}
			<Flex
				bgColor="backgroundAccent"
				w="100%"
				justifyContent="center"
			>
				{/* <TransactionsView /> */}
			</Flex>
		</Flex>
	</ContentContainer>
);
